import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'

import { TextMessageThread } from './TextMessageThread'

export * from './TextMessageThread'
export * from './types'

/**
 * The full-page borrower SMS conversation for this loan.
 *
 * The Servicing menu reaches the thread through Servicing > Messages now. This screen stays
 * because `textMessages` remains a configurable-page component, so a tenant that put Text
 * Messages on a page of its own keeps the screen it built.
 */
export default function TextMessages() {
  return (
    <div className="p-2 md:p-4">
      <div className="flex items-center gap-2 text-[16px] font-bold text-gray-900 border-b pb-1 mb-4 border-gray-200">
        <ChatBubbleLeftRightIcon className="w-5 h-5 text-shade-blue" />
        Text Messages
      </div>
      <TextMessageThread />
    </div>
  )
}
